import {
  CHANNEL_LABELS,
  OUTBOX_STATUS_LABELS,
  type MessageChannel,
  type OutboxStatus,
} from "@shared/modules/x-messagerie";
import { Badge } from "../../../core/components/ui/badge";

type BadgeVariant = "neutral" | "primary" | "success" | "warning" | "danger";

/** Couleurs de statut : tokens seulement, via les variantes de pastille du noyau. */
const STATUS_VARIANT: Record<OutboxStatus, BadgeVariant> = {
  en_attente: "warning",
  envoye: "success",
  simule: "primary",
  echec: "danger",
  annule: "neutral",
};

export function StatusBadge({ status }: { status: OutboxStatus }) {
  return <Badge variant={STATUS_VARIANT[status]}>{OUTBOX_STATUS_LABELS[status]}</Badge>;
}

export function ChannelBadge({ channel }: { channel: MessageChannel }) {
  return <Badge variant="neutral">{CHANNEL_LABELS[channel]}</Badge>;
}
